import { useIsDailyGoalsFeatureEnabled } from 'bundles/daily-goals/features/hooks/useIsDailyGoalsFeatureEnabled';
import leeCoreLex from 'bundles/epic/clients/leeCoreLex';

export function areDailyGoalsEnabled() {
  return leeCoreLex.preview('enableDailyGoals');
}

export const useIsDailyGoalsEnabled = (): {
  isDailyGoalsFeatureEnabled: boolean;
  loadingDailyGoalsFeature: boolean;
} => {
  const isEnabledByEpic = areDailyGoalsEnabled();
  const { enabled: isDailyGoalsFeatureEnabled, loading: loadingDailyGoalsFeature } = useIsDailyGoalsFeatureEnabled({
    shouldSkipQuery: !isEnabledByEpic,
  });
  return { isDailyGoalsFeatureEnabled: isEnabledByEpic && isDailyGoalsFeatureEnabled, loadingDailyGoalsFeature };
};

/**
 * Records an impression for the daily goals experiment at specific impression points.
 * Should be called only at the documented impression points:
 * - LIHP when continue learning modules are present
 * - My Learning tab
 * - In-course experience (daily task island)
 */
export function recordDailyGoalsImpression() {
  return leeCoreLex.get('enableDailyGoals');
}

export function areMmmCelebrationScreensEnabled() {
  return leeCoreLex.preview('enableMmmCelebrationScreens');
}
